<template>
  <div>
    <div class="form-group"> 
        <label>{{ __("forms.OwnersOnModel.ownerTypology") }}</label> 
        <select 
          class="form-control" 
          v-model="model_data.ownable_type"
          :name="form_fields_name_prefix+'[ownable_type]'"
          @change="resetOwnableId()"
        >
          <option value="">...</option>
          <option value="App\Models\Person">{{__("forms.OwnersOnModel.person_typology")}}</option>
          <option value="App\Models\People\PeopleGroup">{{__("forms.OwnersOnModel.person_group_typology")}}</option>
        </select>
    </div>
    <div class="form-group"> 
        <label>{{ __("forms.OwnersOnModel.owner") }}</label> 
        <select 
          class="form-control" 
          :name="form_fields_name_prefix+'[ownable_id]'"
          v-if="model_data.ownable_type == 'App\\Models\\Person'" 
          v-model="model_data.ownable_id" 
          required
        >
          <option value="">...</option>
          <option v-for="person in people_list" :key="person.id" :value="person.id">
              {{ person.fullName }}
          </option>
        </select>
        <select 
          class="form-control" 
          :name="form_fields_name_prefix+'[ownable_id]'"
          v-if="model_data.ownable_type == 'App\\Models\\People\\PeopleGroup'" 
          v-model="model_data.ownable_id" 
          required
        >
          <option value="">...</option>
          <option v-for="group in people_group_list" :key="group.id" :value="group.id">
              {{ group.name }}
          </option>
        </select>
       
    </div> 
  </div>
</template>

<script>
export default {
  methods: {
 
    resetOwnableId() {
      this.model_data.ownable_id = null;
    },
     
  },
  mounted() { 
    
  },
  data() {
    return {
      model_data: this.model,  
    };
  },
  props: {
   
    people_list: {
      type: Array,
      required: true,
    },
    people_group_list: {
      type: Array,
      required: true,
    },
    form_fields_name_prefix: {
      type: String,
      required: true,
    },
    model:{
      type:Object,
      required:true
    }
    
  },
};
</script>
